<script>
	import Navbar from '$lib/components/Navbar.svelte';
	import '../../../app.css';
</script>

<div class="app">
	<Navbar
		foregroundColor="var(--on-surface)"
		backgroundColor="var(--surface-container)"
		logoAndTextsColor="var(--surface)"
		logoInverted={true}
	/>
	
	<main>
		<slot />
	</main>
</div>

<style>
	.app {
		display: flex;
		flex-direction: column;
		min-height: 100vh;
	}
</style>